import { useEsCelular } from '@/lib/useEsEscritorio'
import { formatearMes } from '@/features/grilla/formato'
import type { PublicacionResumen } from '@/lib/schemas/publicaciones'
import { AgendaCelular } from './AgendaCelular'
import { MesCalendario } from './MesCalendario'

interface VistaCalendarioProps {
  mes: string
  publicaciones: PublicacionResumen[]
  esRastro: boolean
  /** Sólo feed o sólo historias: el mes vacío lo dice (DEC-21). */
  filtrando?: boolean
  cargando: boolean
  alAbrir: (id: string) => void
  alCrearEn: (fecha: string) => void
  alMover: (p: PublicacionResumen, fecha: string) => void
}

/**
 * P02 (§8.3). Elige la forma según el ancho: la cuadrícula del mes en
 * escritorio, la agenda por día en celular.
 *
 * El mes vacío se avisa con una línea, pero en escritorio la cuadrícula sigue
 * abajo: el aviso de RASTRO dice "Tocá un día para cargar la primera", y para
 * eso los días tienen que estar a la vista.
 */
export function VistaCalendario({
  mes,
  publicaciones,
  esRastro,
  filtrando = false,
  cargando,
  alAbrir,
  alCrearEn,
  alMover,
}: VistaCalendarioProps) {
  const esCelular = useEsCelular()

  if (cargando) {
    return <p className="py-10 text-center text-sm text-tinta-suave">Cargando…</p>
  }

  const vacio = publicaciones.length === 0

  return (
    <div className="flex flex-col gap-4">
      {vacio && (
        <p
          data-calendario-vacio
          className="rounded-tarjeta bg-tarjeta px-6 py-8 text-center text-sm text-tinta-suave shadow-tarjeta"
        >
          {filtrando
            ? `Ninguna publicación de ${formatearMes(mes).toLowerCase()} coincide con el filtro.`
            : `No hay publicaciones en ${formatearMes(mes).toLowerCase()}.`}
          {esRastro && !filtrando && ' Tocá un día para cargar la primera.'}
        </p>
      )}

      {esCelular ? (
        !vacio && (
          <AgendaCelular
            mes={mes}
            publicaciones={publicaciones}
            alAbrir={alAbrir}
            esRastro={esRastro}
          />
        )
      ) : (
        <MesCalendario
          mes={mes}
          publicaciones={publicaciones}
          esRastro={esRastro}
          alAbrir={alAbrir}
          alCrearEn={alCrearEn}
          alMover={alMover}
        />
      )}
    </div>
  )
}
